import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import MetaTags from "./index";
import config from "@/lib/config";
import routes from "@/lib/routes";
import { jsx as _jsx } from "react/jsx-runtime";
export function tags(channel) {
  var _channel$genres;
  const genre = (channel === null || channel === void 0 || (_channel$genres = channel.genres) === null || _channel$genres === void 0 || (_channel$genres = _channel$genres[0]) === null || _channel$genres === void 0 ? void 0 : _channel$genres.name) || "";
  return {
    title: `${channel.name}【${genre}】の注目の番組 動画配信 | SPOOX(スプークス)`,
    keywords: `注目の番組,${channel.name},SPOOX,スプークス,動画配信,スカパー！`,
    description: `${channel.name}の注目の番組をピックアップ！SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど、様々な動画を配信中です。`,
    og: {
      type: "article",
      url: `${config.host.vod}${routes.channelDetailFeatured(channel.id)}`
    }
  };
}
export default function ChannelFeaturedMetaTags(_ref) {
  let {
    channel
  } = _ref;
  const props = tags(channel);
  return /*#__PURE__*/_jsx(MetaTags, _objectSpread({}, props));
}